export const getImageUrl = (fileName: string): string =>
  `${process.env.RAZZLE_HOST}/${fileName}`;
